/* RESPONSIBLE TEAM: team-knowledge-foundations */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { type Router } from '@ember/routing';
import type Store from '@ember-data/store';
import type IntlService from 'embercom/services/intl';
import type KnowledgeHubEditorService from 'embercom/services/knowledge-hub-editor-service';
import type Transition from '@ember/routing/-private/transition';
import type KnowledgeHubDrawerEditorService from 'embercom/services/knowledge-hub-drawer-editor-service';

export default class Edit extends Route {
  @service declare notificationsService: any;
  @service declare router: Router;
  @service declare store: Store;
  @service declare intl: IntlService;
  @service declare knowledgeHubEditorService: KnowledgeHubEditorService;
  @service declare permissionsService: any;
  @service declare appService: AppService;
  @service declare knowledgeHubDrawerEditorService: KnowledgeHubDrawerEditorService;
  beforeModel(transition: Transition) {
    let params = transition.to.params;

    // Displaying editing, and creating content is now handled by the in-context editor.
    // This route is remaining in place to redirect in case of user bookmarks etc
    if (params.content_id && params.content_type) {
      this.knowledgeHubDrawerEditorService.openEditDrawer({
        routeName: 'apps.app.knowledge-hub.all-content',
        activeContentId: params.content_id,
        activeContentType: params.content_type,
      });
    } else {
      this.router.transitionTo('apps.app.knowledge-hub.all-content');
    }
  }
}
